import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["layoutType", "title", "description", "img", "button", "erid", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { ButtonPromo } from '@sbercloud/uikit-product-button-predefined';
import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { Erid } from '@sbercloud/uikit-product-site-tag';
import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { Typography } from '@snack-uikit/typography';
import { ColorWrapper } from '../../helperComponents/ColorWrapper';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MAP_LAYOUT_TO_TEXT_SIZE = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LAYOUT_TYPE.Desktop, 'l'), LAYOUT_TYPE.DesktopSmall, 'l'), LAYOUT_TYPE.Tablet, 'l'), LAYOUT_TYPE.Mobile, 'm');
export function BannerTertiary(_ref) {
  var layoutType = _ref.layoutType,
    title = _ref.title,
    description = _ref.description,
    img = _ref.img,
    button = _ref.button,
    erid = _ref.erid,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isMobile = layoutType === 'mobile';
  return /*#__PURE__*/_jsxs(ColorWrapper, _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(className, styles.root),
    "data-layout-type": layoutType,
    children: [erid && /*#__PURE__*/_jsx(Erid, {
      className: styles.erid,
      tip: erid.tip,
      appearance: ColorWrapper.getEridAppearance(rest.appearance)
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx("img", {
        className: styles.image,
        src: img,
        alt: title
      }), /*#__PURE__*/_jsxs("div", {
        "data-color-wrapper-role": "text",
        className: styles.texts,
        children: [/*#__PURE__*/_jsx(Typography, {
          size: MAP_LAYOUT_TO_TEXT_SIZE[layoutType],
          className: styles.title,
          purpose: "title",
          family: "sans",
          children: /*#__PURE__*/_jsx(RichText, {
            richText: title
          })
        }), /*#__PURE__*/_jsx(Typography, {
          size: MAP_LAYOUT_TO_TEXT_SIZE[layoutType],
          className: styles.description,
          purpose: "body",
          family: "sans",
          children: /*#__PURE__*/_jsx(RichText, {
            richText: description
          })
        })]
      }), /*#__PURE__*/_jsx(ButtonPromo, _objectSpread(_objectSpread({
        target: "_self"
      }, button), {}, {
        size: "l",
        appearance: ColorWrapper.getButtonAppearance(rest.appearance),
        fullWidth: isMobile
      }))]
    })]
  }));
}